import React from 'react';

export const Ai_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>AI SERVICES</span>,
  },
];

export const First_Title = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '500',
    renderContent: () => <span>UNLIMITED PRE-VISUALIZATION (PRE-VIZ)</span>,
  },
];

export const First_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '400',
    renderContent: () => (
      <span>
        We convert scripts and moodboards into high-fidelity animatics and
        storyboards. Radical iteration to ensure production design is 100% as
        desired.
      </span>
    ),
  },
];

export const Second_Title = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '500',
    renderContent: () => <span>CHARACTER MODELING (CASTING)</span>,
  },
];

export const Second_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '400',
    renderContent: () => (
      <span>
        We create preliminary avatars with specific character traits to define
        the exact look before starting the traditional casting process.
      </span>
    ),
  },
];

export const Third_Title = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '500',
    renderContent: () => <span>IDEATION & FAST PROTOTYPING</span>,
  },
];

export const Third_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '400',
    renderContent: () => (
      <span>
        We develop mock-up versions of entire campaigns (visuals, animations,
        social clips) in hours or days. Perfect for proofs of concept and client
        pitches.
      </span>
    ),
  },
];

export const Fourth_Title = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '500',
    renderContent: () => <span>ON-DEMAND CONTENT & ADAPTATION</span>,
  },
];

export const Fourth_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '400',
    renderContent: () => (
      <span>
        Rapid generation of multiple versions of the same ad for different
        audiences, platforms, or formats without reshoot costs.
      </span>
    ),
  },
];

export const Fifth_Title = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '500',
    renderContent: () => <span>WORLD-BUILDING & ART DESIGN</span>,
  },
];

export const Fifth_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '400',
    renderContent: () => (
      <span>
        Generation of unique environments, costumes, and visual elements. We
        create coherent universes that allow you to see in "post-production"
        mode during "pre-production" stages.
      </span>
    ),
  },
];

export const Sixth_Title = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '500',
    renderContent: () => <span>PREDICTIVE SCRIPT ANALYSIS</span>,
  },
];

export const Sixth_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '400',
    renderContent: () => (
      <span>
        We automatically identify the most complex shots and logistical
        challenges, optimizing the shooting schedule and preventing
        pre-production errors.
      </span>
    ),
  },
];

export const Seventh_Title = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '500',
    renderContent: () => <span>HIGH-FIDELITY EXECUTION</span>,
  },
];

export const Seventh_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '400',
    renderContent: () => (
      <span>
        We connect your project with the most suitable Filmmaker, ensuring
        high-quality cinematic results ready for the brand.
      </span>
    ),
  },
];

export const Artist_Title = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '500',
    renderContent: () => <span>AI ARTISTS</span>,
  },
];

export const Artist_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '400',
    renderContent: () => <span>Created by humans, powered by AI.</span>,
  },
];
